module.exports = __webpack_public_path__ + "img/availability-downtimes.6963beac.svg";